export const ROUTES = {
  ROOT: '/',
  AI_USAGE: '/ai-usage',
  CONTACT_US: '/contact-us',
  COOKIE_PREFERENCES: '/cookie-preferences',
  CLEVERSCORE: '/cleverscore',
  LEGAL_NOTICES: '/legal-notices',
  PERSONAL_DATA: '/personal-data',
  TERMS_OF_USE: '/terms-of-use',
  CONSULTANT_DETAIL: '/consultants/$consultantId',
  CONSULTANTS_LIST: '/consultants',
} as const
